import { Component, Input,OnInit, ViewChild, ElementRef,Output,EventEmitter} from '@angular/core';
declare var $;
import * as moment from 'moment';
@Component({
  selector: 'datatableconfig',
  template: `<div class="text-center" *ngIf="loading"><mat-spinner style="margin:0 auto;" color="indeterminate" [strokeWidth]="3" aria-label="Loading"></mat-spinner><p>Loading Data..</p></div>
        
        <div *ngIf="(!loading)&&datasource.length==0"><h3>No data available</h3></div>
        <div class="dttable-div" [ngStyle]="{'visibility': loading||(datasource.length == 0) ? 'hidden' : 'visible' }">
        <table  class="display nowrap " [ngClass]="classname"  >
            <thead >
                <tr>
                    <th *ngIf="chkstatus">A</th>
                    <th *ngIf="actionstatus">Action</th>
                    <th *ngFor="let col of dtcolumns">{{col}}</th>
                </tr>
                <tr >
                    <th *ngIf="chkstatus"><input type="checkbox" name="select_all" value="1" id="dt-selectall"></th>
                    <th *ngIf="actionstatus"></th>
                    <th *ngFor="let col of dtcolumns"><input style="width: 100%;" [placeholder]="col" name="search-first-name" class="dtsearchinput" type="text"/></th>
                </tr>
            </thead>
            <tbody >
               
            </tbody>
        </table>
        </div>`,
})
export class dataTableConfig implements OnInit {

@Input('classname') classname='tblgrid';
@Input('datasource') datasource=[];
@Input('dtcolumns') dtcolumns=[];
@Input('dtoptions') dtoptionsinput={};
@Input('chkselection') chkstatus=false;
@Input('actionbtns') actionbtns:Array<any>=[];
@Input('anchors') anchors:Array<any>=[];
@Input('loading') loading:boolean;
@Input('domhtml') domhtml = '';

@ViewChild('dataTable',{static:true}) table:ElementRef;

@Output('editrow') editrow = new EventEmitter();
@Output('deleterow') deleterow = new EventEmitter();
@Output('customaction1') customaction1 = new EventEmitter();
@Output('customaction2') customaction2 = new EventEmitter();
@Output('anchoraction1') anchoraction1 = new EventEmitter();
@Output('anchoraction2') anchoraction2 = new EventEmitter();
@Output('chkclick') chkclick = new EventEmitter();
@Output('allchkclick') allchkclick = new EventEmitter();
@Output('rowclick') rowclick = new EventEmitter();
@Output('rowloop') rowloop = new EventEmitter();
dataTableref:any;
actionstatus:boolean=false;
tbodyhtml = '';
nodatamsg = '';
dtOption= {
    rowloop:false,
    "destroy": true,
    "paging":   true,
    "ordering": true,
    orderCellsTop: true,
    "info":     true,
    colReorder: true,
    "scrollX": true,
    "deferRender": true,
    dom: 'lB<"#dt-customhtml">frtip',
    "autoWidth": false,
    "order": [],
    "lengthMenu":  [ [10, 25, 50, -1], [10, 25, 50, "All"] ],
    "language": {
        "lengthMenu": "Show _MENU_ rows",
      },
     buttons: [
                {
                    "extend": "colvis",
                    "text": "Customize Grid",
                    "className": "",
                    columns: '',
                },
                {
                    "extend": "excel",
                    "text": "Export To Excel ",
                    "className": "dt-button-excel",
                    "title": 'export',
                    "extension": '.xlsx'
                }
            ]
  };
    ngOnInit()
    {
        if(this.chkstatus)
        {
            this.dtoptionsinput['columnDefs'].push({
                'targets': 0,
                'searchable':false,
                'orderable':false,
                'className': 'dt-head-center',
              });
        }
        this.actionstatus = this.actionbtns.length>0;
    }
   
    ontblinit(prevtblref)
    {
        if(this.datasource.length > 0)
        {
            if(prevtblref)
            {
                prevtblref.destroy();
            }
             
            this.dtOption= Object.assign(   this.dtOption,this.dtoptionsinput    );
            this.tbodyhtml = '';
            this.dataTableref = $('.'+this.classname).DataTable(this.dtOption);
 
            // $('#dt-customhtml').html('<label style="color:#07D3E0;font-size:15px">Total Quantity:</label>'
            // +'<span style="display:inline-block;width:60px;"><input type="text" id="t_qty" value=""></span>');
            if(this.dtOption.rowloop == true)
            {
                $('#dt-customhtml').css({"display":"inline-block","width":"40vw"});
            }
            
            this.dataTableref.clear().draw();
            for(var z=0;z<this.datasource.length;z++)
            {
                var dataarrsub=[];
                var colindx = 0;
                if(this.chkstatus == true && this.actionstatus == true)    
                {
                    dataarrsub[0] = ' <td ><input type="checkbox" class="dt-chk" value="'+z+'"></td>';
                    dataarrsub[1] = ' <td >';
                    for(var x=0;x<this.actionbtns.length;x++)
                    {
                        dataarrsub[1] += '<button  value="'+z+'" data-action="'+this.actionbtns[x].action+'" class="dt-btnaction '+this.actionbtns[x].class+'">'
                                            +this.actionbtns[x].text+'</button>';
                    }
                    dataarrsub[1] += '</td>';
                    colindx = 2;
                }
                else{
                    colindx = 1;
                    if(this.chkstatus == true)
                    {
                        dataarrsub[0] = ' <td ><input type="checkbox" class="dt-chk" value="'+z+'"></td>'; 
                    }
                    else if(this.actionstatus == true)
                    {
                        dataarrsub[0] = ' <td >';
                        for(var x=0;x<this.actionbtns.length;x++)
                        {
                            dataarrsub[0] += '<button  value="'+z+'" data-action="'+this.actionbtns[x].action+'" class="dt-btnaction '+this.actionbtns[x].class+'">'
                                                +this.actionbtns[x].text+'</button>';
                        }
                        dataarrsub[0] += '</td>';
                    }
                    else
                    {
                        colindx = 0;
                    }
                }
                
                for(var y=0;y<this.dtcolumns.length;y++)
                {
                    if(this.anchors.findIndex(x=>x.colname ==this.dtcolumns[y]) > -1)
                    {
                        var ind = this.anchors.findIndex(x=>x.colname ==this.dtcolumns[y]);
                        dataarrsub[colindx] = '<a href="javascript:void(0)" value="'+z+'" data-action="'+this.anchors[ind].action+'" title="'+this.anchors[ind].title+'"    class="anchoraction">'+this.datasource[z][this.dtcolumns[y]]+'</a>';   
                    }
                    else{
                        dataarrsub[colindx] = this.datasource[z][this.dtcolumns[y]];
                    }
                    colindx++;
                }
                this.dataTableref.row.add(dataarrsub);
                if(this.dtOption.rowloop == true)
                {
                    this.rowloop.emit(z);
                }
                
            }
            this.dataTableref.draw();
            setTimeout(() => {
                $('#dt-customhtml').html(this.domhtml);
            });
            
            var that= this;
            $('.dttable-div thead  input').on( 'keyup', function () {
                that.dataTableref
                    .column( $(this).parent().index()+':visible' )
                    .search( this.value )
                    .draw();
            } );
            $('.dttable-div #dt-selectall').on('click', function(){
                var rows = that.dataTableref.rows({ 'search': 'applied' }).nodes();
                $('.dt-chk', rows).prop('checked',this.checked);
                that.dataTableref.draw();
                var valarr = [];
                if($(this).is(':checked'))
                {
                    $('.dt-chk', rows).each(function(){
                        valarr.push($(this).attr('value'));
                    });
                    that.allchkclick.emit({check:1,val:valarr});
                }
                else
                {
                    that.allchkclick.emit({check:0,val:valarr});
                }
             });
             $('.dttable-div').off().on('click','.dt-chk', function(){
                var indx = $(this).attr('value');
                if($(this).is(':checked'))
                {
                    that.chkclick.emit({check:1,val:indx});
                }
                else
                {
                    that.chkclick.emit({check:0,val:indx});
                }
             });
             $('.dttable-div tbody').off().on( 'click','.dt-btnaction,.anchoraction', function () {
                var act = $(this).attr('data-action');
                var indx = $(this).attr('value');
                that[act].emit(indx);
            });
            $('.dttable-div tbody').on('click', 'tr', function () {
                var data = that.dataTableref.row( this ).data();
                that.rowclick.emit(data);
            } );
            $.fn.dataTable.moment('DD/MM/YYYY HH:mm:ss');
            $.fn.dataTable.moment('DD-MMM-YYYY  HH:mm:ss');
            $.fn.dataTable.moment('DD-MMM-YYYY HH:mm:ss');
            $.fn.dataTable.moment('MM/DD/YYYY HH:mm:ss');
            $.fn.dataTable.moment('MM/DD/YYYY');
            $.fn.dataTable.moment('DD-MMM-YYYY');
            
        }
        else{
            this.nodatamsg = 'No data available';
        }
    }
    
    getcheckedrows()
    {
        console.log(this.dataTableref.rows({ 'search': 'applied' }).nodes());
    }
}